import React from "react"

export default function DefaultResourceSwitch({ isDefault, isDefaultLocked, onDefaultChange }) {
  return (
    <div className="ai-targeting-form__field">
      <div className="ai-targeting-form__default-toggle">
        <div className="ai-targeting-form__default-toggle-left">
          <div className="ai-targeting-form__field-icon ai-targeting-form__field-icon--amber">
            <i className="fas fa-star"></i>
          </div>
          <div>
            <div className="ai-targeting-form__field-label">Ressource par défaut</div>
            <div className="ai-targeting-form__field-hint">
              Diffusée lorsqu'aucune correspondance de ciblage n'est trouvée.
            </div>
          </div>
        </div>
        <label
          className={`ai-targeting-form__switch ${isDefaultLocked ? "ai-targeting-form__switch--disabled" : ""
            }`}
        >
          <input
            type="checkbox"
            checked={isDefault}
            disabled={isDefaultLocked}
            onChange={(e) => onDefaultChange(e.target.checked)}
          />
          <span className="ai-targeting-form__switch-slider"></span>
        </label>
      </div>

      {isDefaultLocked && (
        <div className="ai-targeting-form__warning" style={{ marginTop: 10 }}>
          <i className="fas fa-info-circle"></i>
          <span>Une autre ressource est déjà définie comme ressource par défaut.</span>
        </div>
      )}
    </div>
  )
}
